<template>
    <div id="create-agent-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Add Agent</h1>
                <AgentForm @formSubmitted="createAgent" />
            </section>
        </div>
    </div>
</template>

<script>
import AgentForm from '@/components/forms/AgentForm.vue'
const endpoint = process.env.VUE_APP_API_BASE + '/agents/create'
import axios from 'axios'

export default {
    name: 'AgentsCreate',
    components: {
        AgentForm
    },
    data: function() {
        return {

        }
    },
    methods: {
        createAgent(data) {
            axios.post(endpoint, data)
                .then(response => {
                    console.log(response)
                    alert('Agent created successfully')
                    this.$router.push('/agents')
                })
                .catch(error => {
                    console.log(error.response)
                    if (error.response && error.response.data?.data) {
                        alert(error.response.data.data)
                    }
                    else {
                        alert('Error occurred!')
                        console.log(error)
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
